






























































































































































































































































































































































































































































































































































































































































import { Pagination, MESSAGE_TEMPLATE_TYPE } from '@/common';
import { getStatusColor } from '@/core';
import BaseComponent from '@/core/base.component';
import {
  ConsultResponseV3Dto,
  ConsultResponseV3UpdateDto,
  AdminSendMessageDto,
  AdminDto,
  AdminListDto,
  ConsultResponseV3SendMessageDto,
  SalesRequestDto,
  SalesResponseDto,
  BaeminReportCreateDto,
  BaeminReportUpdateDto,
  CodeHdongDto,
} from '@/dto';
import { PickcookCodeManagementDto } from '@/services/init/dto';
import {
  BEST_FOOD_CATEGORY,
  CONST_BEST_FOOD_CATEGORY,
  BRAND_CONSULT,
  CONST_KB_MEDIUM_CATEGORY,
  KB_MEDIUM_CATEGORY_KOREAN,
  CONST_BAEMIN_CATEGORY_CODE,
  BAEMIN_CATEGORY_CODE,
  KB_MEDIUM_CATEGORY,
} from '@/services/shared';
import { BaseUser } from '@/services/shared/auth';
import { Component } from 'vue-property-decorator';
import CommonCodeService from '@/services/pickcook/common-code.service';
import ConsultResponseV3Service from '@/services/pickcook/consult-response-v3.service';
import toast from '../../../../../resources/assets/js/services/toast.js';
import AdminService from '@/services/admin.service';
import consultResponseService from '@/services/pickcook/consult-response.service.js';
import CodeHdongService from '@/services/pickcook/code-hdong.service';

@Component({
  name: 'ConsultResponseV3Detail',
})
export default class ConsultResponseV3Detail extends BaseComponent {
  private consultResponseV3Dto = new ConsultResponseV3Dto();
  private consultResponseUpdateDto = new ConsultResponseV3UpdateDto();

  private consultResponseV3SendMessageDto = new ConsultResponseV3SendMessageDto();
  private adminSendMessageDto = new AdminSendMessageDto();
  private messageTemplateTypes = MESSAGE_TEMPLATE_TYPE;
  private availableTime = '';
  private selectedTemplateType = MESSAGE_TEMPLATE_TYPE.CONSULT;

  private brandConsultStatus: PickcookCodeManagementDto[] = [];
  private codeManagementDto = new PickcookCodeManagementDto();
  private paginationCode = new Pagination();
  private locationDetailInfo: any = [];
  private selectedFoodCategory = '';
  private bestFoodCategory: BEST_FOOD_CATEGORY[] = [
    ...CONST_BEST_FOOD_CATEGORY,
  ];

  private selectDeleteReason = '';
  private otherDeleteReason = '';
  private deleteReasonText = '';

  private adminList: AdminDto[] = [];
  private adminSearchDto = new AdminListDto();
  private adminTotalCount = null;
  private paginationAdmin = new Pagination();
  private selectedAdmin: AdminDto = new AdminDto(BaseUser);

  private configOptions: any = {
    format: 'YYYY-MM-DD hh:mm A',
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'fas fa-arrow-up',
      down: 'fas fa-arrow-down',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-calendar-check',
      clear: 'far fa-trash-alt',
      close: 'far fa-times-circle',
    },
  };

  private salesRequestDto = new SalesRequestDto();
  private salesResponseDto = new SalesResponseDto();
  private kbMediumCategories: KB_MEDIUM_CATEGORY[] = [
    ...CONST_KB_MEDIUM_CATEGORY,
  ];

  // 배민카테고리
  private baeminReportCreateDto = new BaeminReportCreateDto();
  private baeminReportUpdateDto = new BaeminReportUpdateDto();
  private baeminCategories: BAEMIN_CATEGORY_CODE[] = [
    ...CONST_BAEMIN_CATEGORY_CODE,
  ];

  // hdong code
  private hdongCode;
  private codeHdongAddress = '';
  private codeHdongDto = new CodeHdongDto();
  private meetingTimeArr = [
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
  ];

  // 상권분석 리포트 보기
  getConsultReport() {
    let params = {};
    if (this.consultResponseV3Dto.consultBaeminReport) {
      params = {
        hdongCode: String(
          this.consultResponseV3Dto.consultBaeminReport.hdongCode,
        ),
        kbMediumCategory: this.consultResponseV3Dto.consultBaeminReport
          .mediumCategoryCode,
      };
    }
    const routeData = this.$router.resolve({
      name: 'ConsultReportDetail',
      params: {
        ...params,
      },
    });
    // 새탭으로 열기
    window.open(routeData.href, '_blank');
  }

  // get status color
  getStatusColor(status: BRAND_CONSULT) {
    return getStatusColor(status);
  }

  // get common codes
  getCommonCodes() {
    this.codeManagementDto.category = 'BRAND_CONSULT';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.brandConsultStatus = res.data.items;
    });
  }

  // get location info detail
  getLocationInfoDetail() {
    if (this.consultResponseV3Dto.proformaConsultResult.hdong) {
      ConsultResponseV3Service.getLocationInfoDetail(
        this.consultResponseV3Dto.proformaConsultResult.hdong.hdongCode,
      ).subscribe(res => {
        let filterArray = [...Object.values(res.data)];
        filterArray = filterArray.filter((arr: any) => {
          for (const filter of this.bestFoodCategory) {
            if (arr.mediumCategoryName.includes(filter)) {
              return true;
            }
          }
        });

        this.selectedFoodCategory = filterArray[0].mediumCategoryName;
        this.locationDetailInfo = filterArray.splice(0, 5);

        // console.log('this.locationDetailInfo', this.locationDetailInfo);
      });
    }
  }

  // get cateogry
  getCategory(category: string) {
    this.selectedFoodCategory = category;
  }

  findAdmin(isPagination: boolean) {
    if (!isPagination) {
      this.paginationAdmin.page = 1;
    }
    this.paginationAdmin.limit = 5;
    AdminService.findAll(this.adminSearchDto, this.paginationAdmin).subscribe(
      res => {
        this.adminList = res.data.items;
        this.adminTotalCount = res.data.totalCount;
      },
    );
  }

  selectAdmin(admin: AdminDto) {
    this.selectedAdmin = admin;
  }

  cancelSelection() {
    this.selectedAdmin = new AdminDto(BaseUser);
  }

  paginateSearch() {
    this.findAdmin(true);
  }

  // 담당자 본인으로 정하기
  assignYourselfAdmin() {
    ConsultResponseV3Service.assignAdmin(
      this.consultResponseV3Dto.id,
    ).subscribe(res => {
      this.findOne(this.consultResponseV3Dto.id);
    });
  }

  findOne(id) {
    ConsultResponseV3Service.findOne(id).subscribe(res => {
      if (res) {
        this.consultResponseV3Dto = res.data;
        if (
          this.consultResponseV3Dto.consultBaeminReport &&
          this.consultResponseV3Dto.consultBaeminReport.hdongCode
        ) {
          this.baeminReportUpdateDto = this.consultResponseV3Dto.consultBaeminReport;
          this.getHdong(
            this.consultResponseV3Dto.consultBaeminReport.hdongCode.toString(),
          );
        }

        // this.getLocationInfoDetail();
        this.consultResponseUpdateDto.consultStatus = this.consultResponseV3Dto.consultStatus;
        this.consultResponseUpdateDto.description = this.consultResponseV3Dto.description;
        this.consultResponseUpdateDto.meetingDate = this.consultResponseV3Dto.meetingDate;
        this.consultResponseUpdateDto.meetingTime = this.consultResponseV3Dto.meetingTime;
        // if (
        //   this.consultResponseV3Dto.reservation &&
        //   this.consultResponseV3Dto.reservation.isCancelYn !== 'Y'
        // ) {
        //   this.reservationUpdateDto.reservationDate = this.consultResponseV3Dto.reservation.formatReservationDate;
        //   this.reservationUpdateDto.reservationTime = this.consultResponseV3Dto.reservation.reservationTime;
        //   this.getReservationTimes(
        //     this.consultResponseV3Dto.reservation.reservationDate
        //       .toString()
        //       .slice(0, 10),
        //   );
        // }
      }
    });
  }

  // update consult response
  updateConsultResponse() {
    if (this.selectedAdmin) {
      this.consultResponseUpdateDto.adminId = this.selectedAdmin.no;
    }
    ConsultResponseV3Service.update(
      this.$route.params.id,
      this.consultResponseUpdateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  get messageTemplate() {
    if (this.selectedTemplateType === MESSAGE_TEMPLATE_TYPE.CONSULT) {
      return `[픽쿡 상담안내]\n안녕하세요 ${this.consultResponseV3Dto.name} 창업자님!\n데이터로 창업의 시작과 매출을올려드리는 픽쿡입니다.\n픽쿡을 신청해 주셔서 감사합니다.\n오늘 "${this.availableTime}" 사이에 상담전화를 드리겠습니다.\n감사합니다.`;
    } else if (
      this.selectedTemplateType === MESSAGE_TEMPLATE_TYPE.ONLINE_MEETING
    ) {
      return `[픽쿡 상권분석 일정안내]\n안녕하세요 ${
        this.consultResponseV3Dto.name
      } 창업자님!\n오늘 "${
        this.availableTime
      }"에 픽쿡 상권분석 미팅이 예정되어 있어서 문자드립니다!\n구글 미트로 화상미팅이 진행될 예정이며, 아래 첨부된 링크로 접속이 가능하며, 앱 다운로드가있을 수 있습니다. \n해당 시간에 링크에 입장 하시면 담당자분이 대기 예정입니다.\n감사합니다.\n\n구글 미트 주소: ${
        this.consultResponseV3SendMessageDto.googleMeetUrl
          ? this.consultResponseV3SendMessageDto.googleMeetUrl
          : ''
      }`;
    } else {
      return `[픽쿡 상권분석 일정안내]\n안녕하세요 ${this.consultResponseV3Dto.name} 창업자님!\n오늘 "${this.availableTime}"에 픽쿡 오프라인 미팅이 예정되어 있어서 문자드립니다!\n장소 : 서울시 서초구 강남대로 311\n\n건물에 도착하여 연락주시면 담당자분이 안내드릴 예정입니다.\n건물 내 유료주차 가능하시며, 최초 30분만 무료로 제공됩니다.\n\n감사합니다.`;
    }
  }

  // send massage
  sendMessage() {
    if (!this.availableTime) {
      toast.error('상담시간대를 입력해주세요!');
      return;
    }
    if (
      this.selectedTemplateType === MESSAGE_TEMPLATE_TYPE.ONLINE_MEETING &&
      !this.consultResponseV3SendMessageDto.googleMeetUrl
    ) {
      toast.error('구글 미트 주소를 입력해주세요!');
      return;
    }
    this.consultResponseV3SendMessageDto.message = this.messageTemplate;
    ConsultResponseV3Service.sendMessage(
      this.consultResponseV3Dto.id,
      this.consultResponseV3SendMessageDto,
    ).subscribe(res => {
      if (res) {
        this.consultResponseV3SendMessageDto = new ConsultResponseV3SendMessageDto();
        toast.success('문자가 발송 되었습니다.');
        this.findOne(this.$route.params.id);
        this.$bvModal.hide('send_message');
      } else {
        return;
      }
    });
  }

  createBaeminReport() {
    this.baeminReportCreateDto.averageScore =
      Math.round(this.baeminReportCreateDto.averageScore * 100) / 100;
    ConsultResponseV3Service.postBaeminReport(
      this.$route.params.id,
      this.baeminReportCreateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('입력완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  updateBaeminReport() {
    this.baeminReportUpdateDto.averageScore =
      Math.round(this.baeminReportUpdateDto.averageScore * 100) / 100;
    ConsultResponseV3Service.updateBaeminReport(
      this.consultResponseV3Dto.consultBaeminReport.id,
      this.baeminReportUpdateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  setAddress(res) {
    const geocoder = new window.kakao.maps.services.Geocoder();
    const callback = (results, status) => {
      if (status === window.kakao.maps.services.Status.OK) {
        // console.log('h_code', results[0].address.h_code);
        this.hdongCode = +results[0].address.h_code;
        this.baeminReportCreateDto.hdongCode = +results[0].address.h_code;
        this.baeminReportUpdateDto.hdongCode = +results[0].address.h_code;
        console.log('results', results[0].address);
        if (this.hdongCode) {
          this.codeHdongAddress = `${results[0].address.region_1depth_name} ${results[0].address.region_2depth_name} ${results[0].address.region_3depth_h_name}`;
        }
      }
    };
    geocoder.addressSearch(res.address, callback);
    this.$bvModal.hide('postcode');
  }

  getHdong(code: string) {
    CodeHdongService.getHdongCode(code).subscribe(res => {
      if (res) {
        this.codeHdongDto = res.data;
        if (this.codeHdongDto) {
          this.codeHdongAddress = `${this.codeHdongDto.sidoName} ${this.codeHdongDto.guName} ${this.codeHdongDto.hdongName}`;
        }
      }
    });
  }

  cancelMeeting() {
    this.consultResponseUpdateDto.meetingDate = null;
    this.consultResponseUpdateDto.meetingTime = null;
    this.updateConsultResponse();
  }

  showAddressModal() {
    this.$bvModal.show('postcode');
  }
  created() {
    const id = this.$route.params.id;
    this.findOne(id);
    this.getCommonCodes();
  }
}
